<div class="white-box main-black mt-4 p-4 border-radius">
	<app-study-filters
		[studyInfo]="studyInfo"
		(filtersChanged)="onStudyFiltersChanged($event)"
	></app-study-filters>

	<div class="p-2 mt-2">
		<h3 class="h4 mb-4">{{'utilization.study_utilization_metrics' | translate}}</h3>
		<app-truck-summary-report-performance
			[data]="powerStudyReportData"
			[selectedDays]="selectedDays"
			[totalTrucks]="1"
			[showTooltip]="true"
			[tooltipType]="'study'"
		></app-truck-summary-report-performance>	
	</div>
	<div class="p-2 mt-2">
		<h3 class="h4 mb-4">{{'utilization.daily_usage_metrics' | translate}}</h3>
		<app-daily-usage-metrics
			[data]="powerStudyReportData"
			[selectedDays]="selectedDays"
		></app-daily-usage-metrics>
	</div>

	<div class="p-2 mt-2">
		<app-daily-usage-charts
			[data]="powerStudyReportData"
			[selectedDays]="selectedDays"
		></app-daily-usage-charts>
	</div>

	<div class="row mt-2 ml-2 align-items-center">
		<div>
			<strong class="mr-3">{{'studies.show_soc_chart' | translate}}</strong>
			<div class="form-check form-check-inline slide-toggle-div">
				<mat-slide-toggle [(ngModel)]="showSocChart" name="show_soc_chart"></mat-slide-toggle>
			</div>
		</div>
	</div>
	<app-power-study-soc-chart
		*ngIf="showSocChart"
		[studyInfo]="studyInfo"
		[minDeviceDate]="studyFilters.startDate"
		[maxDeviceDate]="studyFilters.endDate"
		[workingDays]="studyFilters.workingDays"
		[device]="device"
		[useParentFilters]="true"
	></app-power-study-soc-chart>
	
	<app-device-end-voltage-charts
		[siteUtilizationSettings]="siteUtilizationSettings"
		[device]="device"
		[currentSite]="currentSite"
		[deviceInstallationDate]="studyFilters.startDate"
		[maxDate]="studyFilters.endDate"
		[tooltips]="tooltips"
		[deviceType]="deviceType"
		[deviceConfig]="deviceConfig"
		[studyInfo]="studyInfo"
		[useParentFilters]="true"
		[endVoltageFromDate]="studyFilters.startDate"
		[endVoltageToDate]="studyFilters.endDate"
		[workingDays]="studyFilters.workingDays"
	></app-device-end-voltage-charts>

	<app-power-usage-charts
		[hasTruckTypesFilter]="false"
		[deviceTypes]="[deviceType]"
		[deviceInfo]="device?.config_info"
		[studyInfo]="studyInfo"
		[useParentFilters]="true"
		[parentFromDate]="studyFilters.startDate"
		[parentToDate]="studyFilters.endDate"
		[workingDays]="studyFilters.workingDays"
		[siteUtilizationSettings]="siteUtilizationSettings"
	></app-power-usage-charts>
</div>